import { render, staticRenderFns } from "./SupplierCapacityTable.vue?vue&type=template&id=286e6393&scoped=true"
import script from "./SupplierCapacityTable.vue?vue&type=script&lang=js"
export * from "./SupplierCapacityTable.vue?vue&type=script&lang=js"
import style0 from "./SupplierCapacityTable.vue?vue&type=style&index=0&id=286e6393&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286e6393",
  null
  
)

export default component.exports